import api from '@/api/services/api'

const getCollection = params => api({
  method: 'get',
  url: 'excursions/search',
  params
})

const getExcursionsPenalties = params => api({
  method: 'get',
  url: 'excursions/penalties',
  params
})

const getExcursionDetails = params => api({
  method: 'get',
  url: 'excursions/details',
  params
})

export {
  getCollection,
  getExcursionsPenalties,
  getExcursionDetails
}